import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import { DialogActions, Grid, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';

import DriverInputs from './driverInputs';
import SaveChangesButton from './saveChangesButton';
import DriverCheckboxes from './driverCheckboxes';
import { validateDriverName } from '../validators';

const useStyles = makeStyles({
  gridContainer: {
    margin: '0 -8px',
    width: 'calc(100% + 16px)',

    '& > .MuiGrid-item': {
      padding: '8px',
    },
  },
});

const CreateDriverForm = ({
  vehicles,
  sections,
  isSubmitting,
  dirty,
  control,
  showMessage,
}) => {
  const styles = useStyles();
  return (
    <>
      <Grid container spacing={2} className={styles.gridContainer}>
        <Grid item xs={7}>
          <Controller
            name="driverName"
            control={control}
            rules={{
              validate: validateDriverName,
            }}
            render={({ field, formState: { errors } }) => (
              <TextField
                {...field}
                type="text"
                error={!!errors.driverName}
                helperText={errors.driverName?.message}
                label="Driver Name"
                placeholder="Forename Surname"
                variant="outlined"
                fullWidth
                data-testid="add-driver-name"
                inputProps={{ maxLength: 32 }}
              />
            )}
          />
        </Grid>
        <Grid item xs={5}>
          <Controller
            name="displayName"
            control={control}
            render={({ field, formState: { errors } }) => (
              <TextField
                {...field}
                type="text"
                error={!!errors.displayName}
                helperText={
                  errors.displayName?.message || 'Driver Display Name'
                }
                placeholder="Display Name"
                variant="outlined"
                fullWidth
                data-testid="add-driver-display-name"
              />
            )}
          />
        </Grid>
      </Grid>
      <DriverInputs
        isDisabled={false}
        vehicles={vehicles}
        sections={sections}
        control={control}
        gridClassName={styles.gridContainer}
        onShowMessage={showMessage}
      />
      <Grid container spacing={2} className={styles.gridContainer}>
        <Grid item xs={6}>
          <DriverCheckboxes isDisabled={false} control={control} />
        </Grid>
      </Grid>

      <DialogActions>
        <SaveChangesButton disabled={!dirty || isSubmitting} />
      </DialogActions>
    </>
  );
};

export default memo(CreateDriverForm);
